/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { loader } from 'graphql.macro';
import compose from 'recompose/compose';
import { useQuery, useMutation } from '@apollo/react-hooks';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Moment from 'moment';
import useTranslation from '../../../hooks/useTranslation';
import styles from './styles';
import { scrollToTop } from '../../../utilities/commonFunctions';

const RECORD_COUNTS = loader('../../../graphql/schema/home/record-count.graphql');
const UPDATE_SEARCH_SETTINGS = loader('../../../graphql/schema/search/mutations/update-search-settings.graphql');
const UPDATE_ADVANCED_SEARCH_SETTINGS = loader('../../../graphql/schema/search/mutations/update-advanced-search-settings.graphql');
const WHATSNEWS = loader('../../../graphql/schema/home/whats-news.graphql');

const WelcomeBanner = (props) => {
  const { classes, history } = props;
  const { t } = useTranslation();

  const { data } = useQuery(RECORD_COUNTS);
  const whatNewsResp = useQuery(WHATSNEWS);
  const { animation_status: animationStatus } = whatNewsResp?.data?.whatsNews?.[0] ?? {};
  const showAnimatedWhatsNew = animationStatus === '1';

  const { whats_new_date: whatsNewDate } = whatNewsResp?.data?.whatsNews?.[0] ?? {};

  const lastUpdatedDate = whatsNewDate
    ? Moment(whatsNewDate).format('MMM D, YYYY')
    : null;

  const [updateSearchSettings] = useMutation(UPDATE_SEARCH_SETTINGS);

  const [updateAdvancedSearchSettings] = useMutation(UPDATE_ADVANCED_SEARCH_SETTINGS);

  const redirectSearchResult = (value) => {
    const allValues = {
      search_text: '',
      page: 1,
      sort_by: 'relevance',
      userQuery: '',
      initialFilter: {},
      optionalFilters: {},
    };
    localStorage.setItem('searchObj', JSON.stringify(allValues));
    const updatedFilters = {
      product_type: [value],
      sector_name: [],
      continents: [],
      threeie_funded: [],
      fcv_status: [],
      countries: [],
      equity_dimension: [],
      primary_theme: [],
      equity_focus: [],
      year_of_publication: [],
      dataset_available: [],
    };
    const encodedString = btoa(unescape(encodeURIComponent(JSON.stringify(updatedFilters))));
    const encodedSearchString = btoa(unescape(encodeURIComponent(allValues.search_text)));
    const resultsURL = `search-results?search_text=${encodedSearchString}&page=${allValues.page || 1}&per_page=${50}&sort_by=${allValues.sort_by || 'relevance'}&filters=${encodedString}`;
    scrollToTop();
    history.push(resultsURL);
    updateSearchSettings({
      variables: {
        data: {
          keyword: '',
        },
      },
    });

    updateAdvancedSearchSettings({
      variables: {
        data: {
          input_query: '',
        },
      },
    });
  };

  return (
    <div className={classes.welcomeSection}>
      <Container maxWidth="lg" className={classes.container}>
        <div className={classes.welcomeContent}>
          <div className={classes.welcomeText}>
            <Typography variant="h2">{t('welcomeTitle')}</Typography>
            <Typography component="p">
              {t('welcomeDesc')}
            </Typography>
            <div className={classes.bannerButtonContainer}>
              <Link to="/about-us" className={classes.buttonContainer}>
                <Button>
                  {t('aboutDep')}
                </Button>
              </Link>
              <a href="https://www.3ieimpact.org/support-us" rel="noopener noreferrer" target="_blank" className={classes.buttonContainer}>
                <Button className={`${classes.whatsNewButton}`}>
                  {t('donate')}
                </Button>
              </a>
              <Link to="/whats-new" className={classes.buttonContainer}>
                <Button className={`${classes.whatsNewButton} ${showAnimatedWhatsNew ? classes.pulse : ''}`}>
                  {t('seeWhatsNew')}
                </Button>
                {(showAnimatedWhatsNew) && (
                  <span className={classes.badgePingStatic} />
                )}
                {lastUpdatedDate && (
                  <span className={classes.publishedDate}>
                    {t('latestAnnouncement')}
                    {lastUpdatedDate}
                  </span>
                )}
              </Link>
            </div>
          </div>
          <div role="button" tabIndex="0" className={classes.welcomeTextBlock} onKeyPress={() => { }} onClick={() => redirectSearchResult('ier')}>
            <Typography variant="h2">{(data && data.recordCount && data.recordCount.ier > 0) ? data.recordCount.ier : 0}</Typography>
            <Typography component="p">{t('ier')}</Typography>
          </div>
          <div role="button" tabIndex="0" className={classes.welcomeTextBlock} onKeyPress={() => { }} onClick={() => redirectSearchResult('srr')}>
            <Typography variant="h2">{(data && data.recordCount && data.recordCount.srr > 0) ? data.recordCount.srr : 0}</Typography>
            <Typography component="p">{t('srr')}</Typography>
          </div>
          <div role="button" tabIndex="0" className={classes.welcomeTextBlock} onKeyPress={() => { }} onClick={() => redirectSearchResult('egm')}>
            <Typography variant="h2">{(data && data.recordCount && data.recordCount.egm > 0) ? data.recordCount.egm : 0}</Typography>
            <Typography component="p">
              {t('evidenceText')}
              &nbsp;
              <span>{t('gapMaps')}</span>
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
};

WelcomeBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const enhance = compose(
  withStyles(styles),
  withRouter,
);

export default enhance(WelcomeBanner);
